import React, { useState, useEffect, useMemo, useRef } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "./MainPage.css";
import MarkerIcon from "../assets/marker.png";
import Footer from "./Footer";
import LanguageDropdown from "../components/LanguageDropdown";
import LoadingSpinner from "../components/LoadingSpinner";
import settings from "../config/settings.json";
import i18n from "../i18n";

const MainPage = () => {
  const { t } = useTranslation("mainpage");
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);

  const paramGroupId = queryParams.get("groupId");
  const paramUnitCode = queryParams.get("unitcode");

	if (paramUnitCode) {
	  sessionStorage.setItem("G_UNITCODE", paramUnitCode);
	}

	if (paramGroupId) {
	  sessionStorage.setItem("G_GROUPID", paramGroupId);
	}

  const groupId = sessionStorage.getItem("G_GROUPID") || settings.G_groupId || paramGroupId;
  const unitcode = sessionStorage.getItem("G_UNITCODE") || settings.G_UNITCODE || paramUnitCode;

  const [activeTab, setActiveTab] = useState("region");
  const [selectedRegion, setSelectedRegion] = useState("");
  const [searchKeyword, setSearchKeyword] = useState("");
  const [groupList, setGroupList] = useState([]);
  const [locationData, setLocationData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [inputLoading, setInputLoading] = useState(false);

  const searchTimeout = useRef(null);

  useEffect(() => {
    const releasePreviousLocker = async (lockerNo, userId, unitcode) => {
      if (lockerNo) {
        try {
          await fetch("/api/lockerlock/release", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ lockerNo, userId, unitCode: sessionStorage.getItem("UNITCODE") }),
          });
          console.log("잠금 해제 완료:", lockerNo);
        } catch (err) {
          console.warn("잠금 해제 실패:", err);
        }
      }
    };

    const autoMove = async () => {
      const lockerNo = sessionStorage.getItem("SELECTED_LOCKER");
      const userId = sessionStorage.getItem("USER_ID");

      await releasePreviousLocker(lockerNo, userId, unitcode);
      sessionStorage.removeItem("SELECTED_LOCKER");

      if ((location.pathname === "/" || location.pathname === "/MainPage") && !unitcode) {
        const preservedUnitcode = sessionStorage.getItem("UNITCODE");
        sessionStorage.clear();
        sessionStorage.setItem("UNITCODE", preservedUnitcode);

        localStorage.clear();

        localStorage.setItem("i18nextLng", "ko");
        localStorage.setItem("lang", "KR");
        sessionStorage.setItem("langSession", "true");
        i18n.changeLanguage("ko");

        const newUserId = "user_" + Math.random().toString(36).substring(2, 10);
        sessionStorage.setItem("USER_ID", newUserId);
      }

      if (unitcode  && unitcode  !== "") {

        sessionStorage.setItem("UNITCODE", unitcode);

		  try {
			const res = await fetch(`/api/kioskDetail/${unitcode}`);
			if (!res.ok) throw new Error("Failed to fetch kiosk details");
			const data = await res.json();

			sessionStorage.setItem("KIOSK_NM", data.KIOSK_NM);
			sessionStorage.setItem("RatesTYPE", data.RatesTYPE);
			sessionStorage.setItem("DayType", data.DayType);

			navigate("/Menupage");
		  } catch (err) {
			console.error("정보 불러오기 실패:", err);
		  }

      }
    };

    autoMove();
  }, [location.pathname]);

  useEffect(() => {
    setLoading(true);
    fetch("/api/groupList")
      .then((res) => {
        if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);
        return res.json();
      })
      .then((data) => {
        setGroupList(data);

        if (groupId) {
          setActiveTab("region");
          setSelectedRegion(groupId);
          fetch("/api/groupListDetail/" + groupId)
            .then((res) => {
              if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);
              return res.json();
            })
            .then((detailData) => setLocationData(detailData))
            .catch((err) => console.error("초기 그룹 상세 데이터 가져오기 오류:", err))
            .finally(() => setTimeout(() => setLoading(false), 400));
        } else {
          setTimeout(() => setLoading(false), 400);
        }
      })
      .catch((err) => {
        console.error("그룹 데이터 가져오기 오류:", err);
        setTimeout(() => setLoading(false), 400);
      });
  }, [groupId]);

  const handleRegionChange = (e) => {
    const selectedValue = e.target.value;
    setSelectedRegion(selectedValue);
    setSearchKeyword("");
    setLoading(true);

    if (selectedValue) {
      fetch("/api/groupListDetail/" + selectedValue)
        .then((res) => {
          if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);
          return res.json();
        })
        .then((data) => setLocationData(data))
        .catch((err) => console.error("그룹 상세 데이터 가져오기 오류:", err))
        .finally(() => setTimeout(() => setLoading(false), 400));
    } else {
      setLocationData([]);
      setTimeout(() => setLoading(false), 400);
    }
  };

  const handleSearchInputChange = (e) => {
    const keyword = e.target.value;
    setSearchKeyword(keyword);

    if (searchTimeout.current) clearTimeout(searchTimeout.current);

    if (keyword) {
      searchTimeout.current = setTimeout(() => {

      // groupId 포함
      const url = `/api/textgroupList?keyword=${encodeURIComponent(keyword)}${
        groupId ? `&groupId=${groupId}` : ""
      }`;

        fetch(url)
          .then((res) => {
            if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);
            return res.json();
          })
          .then((data) => setLocationData(data))
          .catch((err) => console.error("검색 데이터 가져오기 오류:", err))
		  .finally(() => {
			setInputLoading(false);
		  });
      }, 300);
    } else {
      setLocationData([]);
    }
  };

  const locationsToDisplay = useMemo(() => {
    return locationData.map((loc) => (
      <div className="menu-box" key={loc.UNITCODE} onClick={() => Fnc_CardClick(loc)}>
        <div className="location-info">
          <h2>{loc.GROUP_KIOSK_NM}</h2>
          <p>{loc.KIOSK_NM}</p>
        </div>
        <span
          className="marker-icon"
          style={{
            backgroundImage: `url(${MarkerIcon})`,
            filter: loc.KIOSK_LOGIN_ST === "N" ? "grayscale(100%)" : "none",
          }}
        ></span>
      </div>
    ));
  }, [locationData]);

  const Fnc_CardClick = (loc) => {
    if (loc.KIOSK_LOGIN_ST === "N") {
      alert(t("offline_alert"));
      return;
    }
    sessionStorage.setItem("UNITCODE", loc.UNITCODE);
    sessionStorage.setItem("KIOSK_NM", loc.KIOSK_NM);
    sessionStorage.setItem("RatesTYPE", loc.RatesTYPE);
    sessionStorage.setItem("DayType", loc.DayType);
	
	navigate("/Menupage");
  };

  if (loading && activeTab === "region") return <LoadingSpinner message="Loading..." />;

  return (
    <div className="wrap">
      <header>
        <div className="title" onClick={() => navigate("/")}>
          <h1 dangerouslySetInnerHTML={{ __html: t("select_location") }} />
        </div>
        <LanguageDropdown />
      </header>

      <div className="tab-buttons">
		<button
		  className={activeTab === "region" ? "active" : ""}
		  onClick={() => {
			setActiveTab("region");
			setSearchKeyword("");
			setLocationData([]);

			// groupId가 있으면 선택 영역 복원
			if (groupId) {
			  setSelectedRegion(groupId);
			}

			const regionToUse = groupId || selectedRegion;
			if (regionToUse) {
			  setLoading(true);
			  fetch(`/api/groupListDetail/${regionToUse}`)
				.then((res) => {
				  if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);
				  return res.json();
				})
				.then((data) => setLocationData(data))
				.catch((err) => console.error("그룹 상세 데이터 가져오기 오류:", err))
				.finally(() => setTimeout(() => setLoading(false), 400));
			}
		  }}
		>
		  {t("group_search")}
		</button>
        <button
          className={activeTab === "search" ? "active" : ""}
          onClick={() => {
            setActiveTab("search");
            setSelectedRegion("");
            setLocationData([]);
            setSearchKeyword("");
          }}  >
          {t("search_search")}
        </button>
      </div>

      {activeTab === "region" ? (
        <div className="select-wrapper">
          <select id="regionSelect" value={selectedRegion} onChange={handleRegionChange}  disabled={!!groupId}>
            <option value="">{t("please_select")}</option>
            {groupList.map((group) => (
              <option key={group.GROUP_KIOSK_SQ} value={group.GROUP_KIOSK_SQ}>
                {group.GROUP_KIOSK_NM}
              </option>
            ))}
          </select>
        </div>
      ) : (
        <div className="search-wrapper">
          <input  type="text" placeholder={t("search_placeholder")} value={searchKeyword} onChange={handleSearchInputChange}  />
        </div>
      )}

      {inputLoading && (
        <div className="search-loading-overlay">
          <div className="search-loading-spinner"></div>
          <div className="search-loading-text">{t("searching")}</div>
        </div>
      )}

      <div className="scroll-area">
        <div className="center-boxes">{locationsToDisplay}</div>
      </div>

      <Footer />
    </div>
  );
};

export default MainPage;
